import React from "react";
import { useLocalization } from "@i18n";
import { buildAssetUrl } from "@shared/utils";
import { GeneralDashboardCard } from "./GeneralDashboardCard";
import { GeneralDashboardFieldGrid, FieldItem } from "./GeneralDashboardFieldGrid";
import { GeneralDashboardTenantSummary } from "../api/generalDashboard/generalDashboard.types";

interface GeneralTenantSummaryCardProps {
  data: GeneralDashboardTenantSummary | null;
  onMenuClick: () => void;
}

export const GeneralTenantSummaryCard: React.FC<GeneralTenantSummaryCardProps> = ({
  data,
  onMenuClick,
}) => {
  const { translate } = useLocalization();
  const [imgError, setImgError] = React.useState(false);

  const fields: FieldItem[] = [
    {
      labelKey: "general.dashboard.tenantSummary.clientName",
      value: data?.name,
    },
    {
      labelKey: "general.dashboard.tenantSummary.cnpj",
      value: data?.cnpj,
    },
    {
      labelKey: "general.dashboard.tenantSummary.cep",
      value: data?.address?.zipCode,
    },
    {
      labelKey: "general.dashboard.tenantSummary.responsibleName",
      value: data?.responsible?.name,
    },
  ];

  const logoUrl = data?.logo && !imgError ? buildAssetUrl(data.logo) : null;

  return (
    <GeneralDashboardCard
      title={translate("general.dashboard.tenantSummary.title")}
      titleVariant="hidden"
      headerSlot={
        logoUrl ? (
          <img
            src={logoUrl}
            alt={translate("general.dashboard.tenantSummary.logoAlt")}
            className="h-10 max-w-[119px] object-contain object-left"
            onError={() => setImgError(true)}
          />
        ) : null
      }
      onMenuClick={onMenuClick}
      menuTestId="more-options-gs3-cliente"
    >
      <GeneralDashboardFieldGrid fields={fields} variant="identity" />
    </GeneralDashboardCard>
  );
};
